import { Api } from 'lib/api.mjs';

/**
 * Authentication.
 *
 * loginUser runs before there is a token, so it opts out of the Authorization
 * header: sending a stale one would 401 and sign out the person signing in.
 */

/** @param {{ username: string, password: string }} payload */
export function loginUser({ username, password, organization }) {
  // The server names the field `email`; the form asks for a username. The
  // mapping belongs here rather than in the component.
  return Api.post('/login', { body: { email: username, password, ...(organization ? { organization } : {}) }, auth: false });
}
